module.exports = __webpack_public_path__ + "static/media/aisia.ecf36777.png";